module.exports = __webpack_public_path__ + "img/e98c6eb.jpg";